<div id="app-user-import-form-dialog">
  <mat-dialog-content>
    <div class="dialog-content-wrapper">
      <mat-toolbar matDialogTitle class="mat-primary">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">{{
            'GENERAL.TITLE.IMPORTUSER' | translate
          }}</span>
          <button
            mat-icon-button
            (click)="matDialogRef.close()"
            aria-label="Close dialog"
            #fileImportInput>
            <mat-icon>close</mat-icon>
          </button>
        </mat-toolbar-row>
      </mat-toolbar>

      <mat-horizontal-stepper
        class="mat-elevation-z1 mat-stepper-horizontal"
        [linear]="true"
        labelPosition="bottom">
        <mat-step>
          <div fxFlex="1 0 auto" fxLayout="column">
            <input
              autoComplete="on"
              type="file"
              (change)="fileChangeListener($event)"
              id="actual-btn"
              hidden
              accept=".csv" />

            <!-- our custom upload button -->
            <label for="actual-btn" class="mat-raised-button file-upload-label">
              {{ 'USERS.IMPORTUSERS.FILEUPLOAD' | translate }}</label
            >

            <!-- name of file chosen -->
            <span id="file-chosen">{{ filename }}</span>

            <div
              class="general-container"
              fxLayout="row"
              fxLayoutAlign="center center">
              <a href="../../../../assets/template/importusertemplate.csv">
                <button
                  class="btn-container"
                  mat-raised-button
                  type="button"
                  color="primary">
                  <mat-icon>insert_drive_file </mat-icon>
                  <span>{{ 'USERS.IMPORTUSERS.TEMPLATE' | translate }} </span>
                </button>
              </a>
              <button
                mat-raised-button
                matStepperNext
                type="button"
                color="accent"
                [disabled]="!isFileUploaded">
                {{ 'GENERAL.NEXT' | translate }}
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step cdk-scrollable>
          <div fxFlex="1 0 auto" fxLayout="column">
            <div fxLayoutGap="15px">
              <table
                id="gridContainer"
                mat-table
                [dataSource]="dataSource"
                matSort
                (matSortChange)="sortData($event)"
                multiTemplateDataRows>
                <ng-container matColumnDef="officialFirstName">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="officialFirstName"
                    class="sortable">
                    {{ 'USERS.SINGLE.INFO.OFFICIALFIRSTNAME' | translate }}
                    <mat-icon
                      [style.color]="
                        sortedValue !== 'officialFirstName'
                          ? '#757575'
                          : 'transparent'
                      "
                      class="sort-icon"
                      >sort</mat-icon
                    >
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.officialFirstName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="officialLastName">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="officialLastName"
                    class="sortable">
                    {{ 'USERS.SINGLE.INFO.OFFICIALLASTNAME' | translate }}
                    <mat-icon
                      [style.color]="
                        sortedValue !== 'officialLastName'
                          ? '#757575'
                          : 'transparent'
                      "
                      class="sort-icon"
                      >sort</mat-icon
                    >
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.officialLastName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="dateOfBirth">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'USERS.SINGLE.INFO.DATEOFBIRTH' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.dateOfBirth }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="gender">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="gender"
                    class="sortable">
                    {{ 'USERS.SINGLE.INFO.GENDER' | translate }}
                    <mat-icon
                      [style.color]="
                        sortedValue !== 'gender' ? '#757575' : 'transparent'
                      "
                      class="sort-icon"
                      >sort</mat-icon
                    >
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.gender }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="firstName"
                    class="sortable">
                    {{ 'USERS.SINGLE.INFO.FIRSTNAME' | translate }}
                    <mat-icon
                      [style.color]="
                        sortedValue !== 'firstName' ? '#757575' : 'transparent'
                      "
                      class="sort-icon"
                      >sort</mat-icon
                    >
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.firstName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="lastName"
                    class="sortable">
                    {{ 'USERS.SINGLE.INFO.LASTNAME' | translate }}
                    <mat-icon
                      [style.color]="
                        sortedValue !== 'lastName' ? '#757575' : 'transparent'
                      "
                      class="sort-icon"
                      >sort</mat-icon
                    >
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.lastName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'USERS.SINGLE.INFO.EMAIL' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.email }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="phone">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'USERS.SINGLE.INFO.PHONE' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.phone }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="expand">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button (click)="toggleRow(element)">
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="expandedDetail">
                  <td
                    mat-cell
                    *matCellDef="let element"
                    [attr.colspan]="displayedColumns.length">
                    @if (expandedElement === element) {
                      <div class="expanded-detail">
                        @if (windowWidth <= 1300) {
                          <p>
                            <strong>
                              {{ 'USERS.SINGLE.INFO.PHONE' | translate }}:
                            </strong>
                            {{ element.phone }}
                          </p>
                        }
                        @if (windowWidth <= 1150) {
                          <p>
                            <strong>
                              {{ 'USERS.SINGLE.INFO.EMAIL' | translate }}:
                            </strong>
                            {{ element.email }}
                          </p>
                        }
                        @if (windowWidth <= 1000) {
                          <p>
                            <strong>
                              {{ 'USERS.SINGLE.INFO.LASTNAME' | translate }}:
                            </strong>
                            {{ element.lastName }}
                          </p>
                        }
                        @if (windowWidth <= 900) {
                          <p>
                            <strong>
                              {{ 'USERS.SINGLE.INFO.FIRSTNAME' | translate }}:
                            </strong>
                            {{ element.firstName }}
                          </p>
                        }
                        @if (windowWidth <= 750) {
                          <p>
                            <strong>
                              {{ 'USERS.SINGLE.INFO.GENDER' | translate }}:
                            </strong>
                            {{ element.gender }}
                          </p>
                        }
                        @if (windowWidth <= 650) {
                          <p>
                            <strong>
                              {{ 'USERS.SINGLE.INFO.DATEOFBIRTH' | translate }}:
                            </strong>
                            {{ element.dateOfBirth }}
                          </p>
                        }
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.AVS' | translate }}:
                          </strong>
                          {{ element.avs }}
                        </p>
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.ADDRESS' | translate }}:
                          </strong>
                          {{ element.address }}
                        </p>
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.NPA' | translate }}:
                          </strong>
                          {{ element.zip }}
                        </p>
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.LOCALITY' | translate }}:
                          </strong>
                          {{ element.locality }}
                        </p>
                        <p>
                          <strong>
                            {{
                              'USERS.SINGLE.INFO.PREFERREDLANGUAGE' | translate
                            }}:
                          </strong>
                          {{ element.preferredLanguage }}
                        </p>
                        <p>
                          <strong>
                            {{
                              'TABLE.IMPORTUSERS.HEADER.TWOFACTORAUTHTYPE'
                                | translate
                            }}:
                          </strong>
                          {{ element.twoFactorAuthType }}
                        </p>
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.SCHOOL' | translate }}:
                          </strong>
                          {{ element.groupEtablissementList }}
                        </p>
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.CANTON' | translate }}:
                          </strong>
                          {{ element.canton }}
                        </p>
                        <p>
                          <strong>
                            {{
                              'USERS.SINGLE.INFO.INITIALPASSWORD' | translate
                            }}:
                          </strong>
                          {{ element.password }}
                        </p>
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.TITLE' | translate }}:
                          </strong>
                          {{ element.title }}
                        </p>
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.CLASS' | translate }}:
                          </strong>
                          {{ element.classe }}
                        </p>
                        <p>
                          <strong>
                            {{ 'USERS.SINGLE.INFO.ROLES' | translate }}:
                          </strong>
                          {{ element.rolesList }}
                        </p>
                        <p>
                          <strong>
                            {{
                              'TABLE.IMPORTUSERS.HEADER.ORGANISATION'
                                | translate
                            }}:
                          </strong>
                          {{ element.organisationList }}
                        </p>
                      </div>
                    }
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="
                    let row;
                    let index = dataIndex;
                    columns: displayedColumns
                  "
                  class="element-row"
                  [ngClass]="{ alternate: index % 2 === 0 }"></tr>
                <tr
                  mat-row
                  *matRowDef="
                    let row;
                    let index = dataIndex;
                    columns: ['expandedDetail']
                  "
                  class="detail-row"
                  [ngClass]="{ alternate: index % 2 === 0 }"></tr>
              </table>
              <mat-paginator
                [hidePageSize]="true"
                [pageSize]="5"
                showFirstLastButtons>
              </mat-paginator>
            </div>

            <div
              class="general-container"
              fxLayout="row"
              fxLayoutAlign="center center">
              <button
                class="btn-container"
                mat-raised-button
                matStepperPrevious
                type="button"
                color="accent">
                {{ 'GENERAL.PREVIOUS' | translate }}
              </button>
              <button
                mat-raised-button
                matStepperNext
                type="button"
                color="accent">
                {{ 'GENERAL.NEXT' | translate }}
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step>
          <div fxFlex="1 0 auto" fxLayout="column">
            @if (isBusy) {
              <div
                class="general-container"
                fxLayout="row"
                fxLayoutAlign="center center">
                <mat-progress-spinner
                  [color]="spinner.color"
                  [mode]="spinner.mode"
                  [value]="spinner.value"
                  [diameter]="spinner.diameter">
                </mat-progress-spinner>
              </div>
            }

            <mat-progress-bar
              mode="determinate"
              class="mat-progress-bar"
              value="{{ progressvalue }}"></mat-progress-bar>

            <div class="userIndexCount">
              {{ createdUserIndex }} / {{ csvRecords.length }}
            </div>

            @if (isBusy || isCompleted) {
              <mat-accordion class="report-accordion">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Success ({{ usernames.length }})
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div>
                    <ul class="import-container">
                      @for (successuser of usernames; track successuser) {
                        <li>
                          <div>{{ successuser.User }}</div>
                          <div>{{ successuser.Username }}</div>
                        </li>
                      }
                    </ul>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Errors ({{ errorsimport.length }})
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div>
                    <ul class="import-container">
                      @for (erroruser of errorsimport; track erroruser) {
                        <li>
                          <div>{{ erroruser.User }}</div>
                          <div>{{ erroruser.Username }}</div>
                        </li>
                      }
                    </ul>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            }

            @if (!isCompleted) {
              <div
                class="general-container"
                fxLayout="row"
                fxLayoutAlign="center center">
                <button
                  class="btn-container"
                  mat-raised-button
                  matStepperPrevious
                  type="button"
                  color="accent"
                  [disabled]="isBusy">
                  {{ 'GENERAL.PREVIOUS' | translate }}
                </button>
                <button
                  mat-raised-button
                  type="button"
                  color="warn"
                  (click)="importUsers()"
                  [disabled]="isCompleted || isBusy">
                  {{ 'USERS.IMPORTUSERS.STEP.VALIDATE' | translate }}
                </button>
              </div>
            }
            @if (isCompleted) {
              <div
                class="general-container"
                fxLayout="row"
                fxLayoutAlign="center center">
                <a [href]="fileUrl" download="reportImportUser.txt">
                  <button
                    class="btn-container"
                    mat-raised-button
                    type="button"
                    color="accent">
                    {{ 'USERS.IMPORTUSERS.STEP.REPORT' | translate }}
                  </button>
                </a>
              </div>
            }
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </mat-dialog-content>
</div>
